<template>
  <span>{{ startsIn }}</span>
</template>

<script>
import { DateTime, Duration } from "luxon";

export default {
  name: "StartsInBadge",
  props: ["stream"],
  data() {
    return {
      now: DateTime.local().setZone("UTC").set({ milliseconds: 0 }),
      end: DateTime.fromISO(this.stream.starts_at).set({
        milliseconds: 0,
      }),
      startTimeHr: DateTime.fromISO(this.stream.starts_at)
        .set({ milliseconds: 0 })
        .toFormat("dd.MM.y hh:mm"),
      tick: null,
    };
  },
  watch: {
    "stream.starts_at": function () {
      this.end = DateTime.fromISO(this.stream.starts_at).set({
        milliseconds: 0,
      });
    },
  },
  methods: {
    getTimeWordSuffix: (duration) => (duration === 1 ? "" : "s"),
  },
  computed: {
    infoMessage() {
      if (this.stream.stopped_at != null) {
        return "Stream is finished";
      }
      if (this.stream.status == "pause") {
        return "Stay tuned, this stream will resume soon!";
      }
      return "Stay tuned, this stream will start soon!";
    },
    startsAtRemaining() {
      return this.end.diff(this.now).toObject();
    },
    startsAtRemainingHr() {
      return Duration.fromObject(this.startsAtRemaining).toFormat("hh:mm:ss");
    },
    startsAtIsPast() {
      return this.now >= this.end;
    },
    startsInMoreThan24Hours() {
      return this.end.diff(this.now, "days").days > 1;
    },
    startsIn() {
      const time = Duration.fromObject(this.startsAtRemaining);

      const daysDistance = Math.floor(time / (1000 * 60 * 60 * 24));
      const hoursDistance = Math.floor(
        (time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutesDistance = Math.floor(
        (time % (1000 * 60 * 60)) / (1000 * 60)
      );
      const secondsDistance = Math.floor((time % (1000 * 60)) / 1000);

      if (daysDistance < 0) {
        return `starting`;
      } else if (daysDistance > 0) {
        return `in ${daysDistance} day${this.getTimeWordSuffix(daysDistance)}`;
      } else if (hoursDistance) {
        return `in ${hoursDistance} hour${this.getTimeWordSuffix(
          hoursDistance
        )}`;
      } else if (minutesDistance) {
        return `in ${minutesDistance + 1} min`;
      } else if (secondsDistance) {
        return `in ${secondsDistance} sec`;
      } else {
        return `starting`;
      }

      // if (daysDistance >= 24) {
      //   clearInterval(this.tick);
      //   return `Stream will go live on ${this.end
      //     .setZone("GMT")
      //     .toFormat("EEE, dd MMM y HH:mm")} GMT`;
      // } else if (hoursDistance == 0) {
      //   if (minutesDistance > 0) {
      //     return `The stream will start here in: ${
      //       minutesDistance + 1
      //     } minute${this.getTimeWordSuffix(minutesDistance + 1)}`;
      //   } else {
      //     return `The stream will start here in: ${secondsDistance} second${this.getTimeWordSuffix(
      //       secondsDistance
      //     )}`;
      //   }
      // } else if (hoursDistance > 0 && daysDistance === 0) {
      //   return `The stream will start here in: ${hoursDistance} hour${this.getTimeWordSuffix(
      //     hoursDistance
      //   )} ${minutesDistance + 1} minute${this.getTimeWordSuffix(
      //     minutesDistance + 1
      //   )}.`;
      // } else {
      //   return `in ${daysDistance} day${this.getTimeWordSuffix(
      //     daysDistance
      //   )} ${hoursDistance} hour${this.getTimeWordSuffix(hoursDistance)} ${
      //     minutesDistance + 1
      //   } minute${this.getTimeWordSuffix(minutesDistance + 1)}`;
      // }
    },
  },
  mounted() {
    this.tick = setInterval(() => {
      this.now = DateTime.local().setZone("UTC").set({ milliseconds: 0 });
    }, 1000);
  },
};
</script>

<style scoped>
h4 {
  color: white !important;
  font-family: "OpenSans" !important;

  padding: 10px 0;
  font-size: 0.9rem;
}
</style>
